module.exports = __webpack_public_path__ + "img/netstar-loader.e18a0f85.gif";